export const localeString = (valor: number) => {
    return valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}